module.exports = __webpack_public_path__ + "img/blackheathhair.aa0f7c13.jpg";